import gs1Instance from '../api-index'

const { post, get, patch } = gs1Instance;

const createClient = async (payload) => {
    const response = await post("/api/v1/clients/onboard", payload);
    return response.data;
};

const checkClient = async (payload) => {
	const response = await post("/api/v1/clients/check", payload);
	return response.data;
};

const checkClientProducts = async (payload) => {
	const response = await post("/api/v1/clients/check-products", payload);
	return response.data;
};

const checkClientLocations = async (payload) => {
	const response = await post("/api/v1/clients/check-locations", payload);
	return response.data;
};

const editClientProduct = async (payload) => {
	const response = await patch("/api/v1/clients/products", payload);
	return response.data;
};

const editClientLocation = async (payload) => {
	const response = await patch("/api/v1/clients/locations", payload);
	return response.data;
};

const getClientProducts = async (clientId) => {
    const response = await get(`/api/v1/clients/user-products/${clientId}`);
    return response.data
}

const getClientLocations = async (clientId) => {
    const response = await get(`/api/v1/clients/user-locations/${clientId}`);
    return response.data
}

const getAllClients = async (params = {}) => {
	const response = await get(`/api/v1/clients/tenants`, { params });
	return response.data;
};

const getClientById = async (clientId) => {
	const response = await get(`/api/v1/clients/tenants/${clientId}`);
	return response.data;
};

export {
	createClient,
	checkClient,
	checkClientProducts,
	checkClientLocations,
	editClientProduct,
	editClientLocation,
	getClientProducts,
	getClientLocations,
    getAllClients,
    getClientById,
};